module.exports = __webpack_public_path__ + "media/images/emblems/Collinadoro_stemma_colori-2a348e1e152615c8aba240ac74abcaa3.svg";